module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5gMPCBIdBut1CwAAAFNJREFUeNrt2LERADAMAjEn+++MJ0iXo5JG+A5mAAAAaDtJIsPblUAggQQSSCCBAAAA4BeftDUvkEACCSSQQAAAANDik7bmBRJIIIEEEggAAABaFkfzDCKOQsUjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/menu.png
// module id = Hq5l
// module chunks = 1